import { createTypedRouter, LayoutRoute, RootRoute, Route } from "@soft-db/typed-router";
import { createWebHistory, RouteLocationNamedRaw, RouteLocationRaw } from "vue-router";
import { FeatureType } from "../stores/features";
import { Permission } from "../stores/permission";
import auditRoute from "./audit";
import authRoutes from "./auth";
import dashboardRoutes from "./dashboard";
import distributorRoutes from "./distributor";
import docRoutes from "./doc";
import errorsRoutes from "./errors";
import { initRouterGuards } from "./guards";
import { integrityRoutes } from "./integrity";
import loginRoutes from "./login-public";
import mapRoutes from "./map";
import profileRoutes from "./profile";
import reportRoutes from "./report";
import sitesRoutes from "./sites";
import spacesRoutes from "./spaces";
import stationsRoutes from "./stations";

declare module "vue-router" {
	interface RouteMeta {
		ignoreAuth?: boolean;
		disabled?: boolean;
		/**
		 * Can be an array of permission
		 * If it's an array, the permission check use a OR
		 */
		permission?: Permission | Permission[];
		feature?: FeatureType;
		softdBOnly?: boolean;
	}
}

const root = RootRoute.create({
	children: [
		new Route({
			name: "__index_map__",
			path: "",
			redirect: { name: "map" },
		}),
		new Route({
			name: "__legacy_default__",
			path: "default",
			redirect: { name: "map" },
		}),
		loginRoutes,
		new LayoutRoute({
			name: "empty",
			component: () => import("@/layouts/empty-state.vue"),
			path: "",
			children: [authRoutes],
		}),
		new Route({
			name: "eula",
			path: "eula",
			component: () => import("@/pages/eula.vue"),
			meta: {
				ignoreAuth: true,
			},
		}),
		new LayoutRoute({
			name: "default",
			component: () => import("@/layouts/default.vue"),
			path: "",
			children: [
				dashboardRoutes,
				docRoutes,
				mapRoutes,
				profileRoutes,
				sitesRoutes,
				integrityRoutes,
				stationsRoutes,
				errorsRoutes,
				spacesRoutes,
				distributorRoutes,
				auditRoute,
				reportRoutes,
			],
		}),
	],
});

export const { router } = createTypedRouter(
	{
		history: createWebHistory(),
		scrollBehavior(_, __, savedPosition) {
			if (savedPosition) {
				return savedPosition;
			} else {
				return { top: 0 };
			}
		},
	},
	root
);

initRouterGuards(router);

/**
 * Resolve a typed route.
 * If the route is disabled, it will return null
 */
export function createNavigation(options: RouteLocationRaw) {
	const resolved = router.resolve(options as any);
	if (resolved.meta.disabled) return null;

	return options as RouteLocationNamedRaw;
}

export default router;
